module.exports = __webpack_public_path__ + "static/media/twitter.a7e10aa2.md";